import React from 'react';
import Dropzone from 'react-dropzone';
import { useToast } from 'context/ToastContext';
import { toastConstant } from 'constants/toastmessage';

export const DEFAULT_ACCEPT =
  '.jpg, .jpeg, .png, .heic, .heif, .pdf, .doc, .docx, .xls, .xlsx, .txt, .mov, .wav, .mp3, .rtf, .mpeg, .mp4, .aac, .3gp, .avi, .wmv, .wma, .csv';

export const DEFAULT_MAX_FILES = 20;

function FileDropzone({
  value = [],
  onChange,
  accept = DEFAULT_ACCEPT,
  maxFiles = DEFAULT_MAX_FILES,
  multiple = true,
  allowDirectory = false,
  disabled = false,
  placeholder,
  className = '',
  noDragEventsBubbling = false,
  onDropTransform,
  ...rest
}) {
  const { addToast } = useToast();
  const currentFiles = Array.isArray(value) ? value : [];

  const handleDrop = (acceptedFiles, fileRejections) => {
    const hasTooManyFiles = fileRejections?.some((rejection) => rejection.errors?.some((err) => err.code === 'too-many-files'));
    if (hasTooManyFiles) {
      addToast(false, toastConstant.toasterType.WARN, toastConstant.header.WARNINIG, toastConstant.message.FILE_UPLOAD_LIMIT_EXCEEDED);
      return;
    }
    if (!acceptedFiles?.length) return;
    let newFiles = onDropTransform ? onDropTransform(acceptedFiles, currentFiles) : acceptedFiles;
    if (!multiple) {
      newFiles = newFiles.slice(0, 1);
    }
    const updated = multiple ? [...currentFiles, ...newFiles] : newFiles;
    onChange?.(updated);
  };

  return (
    <Dropzone
      noDragEventsBubbling={noDragEventsBubbling}
      onDrop={handleDrop}
      accept={accept}
      multiple={multiple}
      disabled={disabled}
      maxFiles={multiple ? maxFiles - currentFiles.length : 1}
      {...(allowDirectory ? { directory: '' } : {})}
      {...rest}
    >
      {({ getRootProps, getInputProps, isDragActive }) => (
        <section>
          <div
            {...getRootProps()}
            className={`text-center d-flex flex-column justify-content-center align-items-center file-manager-uploader mb-2 p-3 ${className} ${
              isDragActive ? 'border-primary bg-light' : ''
            }`}
          >
            <input {...getInputProps()} {...(allowDirectory ? { directory: '' } : {})} />
            <i className="icon-doc-add mb-2 pointer" />
            <p className="F-size14 mb-0">
              {placeholder || (isDragActive ? 'Drop files here...' : 'Click or drag file/folder to this area to upload')}
            </p>
          </div>
        </section>
      )}
    </Dropzone>
  );
}

export default FileDropzone;
